import type { NavigationItemType } from '@signanthealth/modular-ui';
import { useEffect, useState } from 'react';

import ProductSupportConfig from '../assets/data/ProductSupportConfig.json';
import { getProductIcon } from '../components/icon';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { selectSelectedProductName, setSelectedProduct } from '../store/slices/productSlice';
import { type Product, type ProductName } from '../types/common.types';

export const useProductNavigation = () => {
  const dispatch = useAppDispatch();
  const selectedProductName = useAppSelector(selectSelectedProductName);
  const [navigationItems, setNavigationItems] = useState<NavigationItemType[]>([]);

  useEffect(() => {
    const items: NavigationItemType[] = ProductSupportConfig.products.map((product: Product) => ({
      id: product.productcode,
      text: product.label,
      active: selectedProductName === product.label,
      handleClick: () => dispatch(setSelectedProduct(product.label as ProductName)),
      icon: () => getProductIcon(product.label, selectedProductName === product.label),
    }));
    setNavigationItems(items);
  }, [selectedProductName, dispatch]);

  return {
    selectedProductName,
    navigationItems,
  };
};
